
import Table from "./components/Table";
import RoleModal from './components/RoleModal';

import { getData, deleteData } from './services/api';
import { useSession } from './assets/auth/SessionContext';
import { useEffect, useState } from "react";


const Roles = () => {
    const { session } = useSession();

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [type] = useState("roles")

    async function remove(ref: string) {
        try {
            await deleteData(session, `roles/${ref}`, null)

            return { success: true, message: "Role removed" };
        } catch (err: any) {
            return { success: false, message: err.message };
        }
    }

    useEffect(() => {

        getData(session, `roles`, null).then(roleData => {
            setData(roleData)
            setIsLoading(false);
        }).catch(err => {
            setError(err);
            setIsLoading(false);
        });
    }, []);

    if (isLoading || (!data && !error)) {
        // Render loading indicator or placeholder while data is being fetched
        return (
            <div className="flex">
                <div className="table-container">

                </div>
            </div>
        )
    }

    return (
        <div className="flex">
            <div className="table-container">
                <Table data={data} error={error} type={type} remove={remove} modal={<RoleModal />} />
            </div>
        </div>
    )
}

export default Roles; 